import Cookies from 'js-cookie'

const RLE_COOKIE = 'rle-rs'

interface RleCookie {
  lead_id: string
  created: number
}

export const isDuplicateUser = (leadId?: string): boolean => {
  if (leadId) {
    const cookie: RleCookie = Cookies.getJSON(RLE_COOKIE)
    return cookie.lead_id !== leadId
  }
  return !!Cookies.get(RLE_COOKIE)
}

export const setRleCookie = (leadId: string): void => {
  Cookies.set(RLE_COOKIE, { lead_id: leadId, created: Date.now() }, { expires: 7 })
}
